import { validator } from "LIB/validate-this";
import {
  NO_QUOTE,
  EXCHANGE_ONLY,
  PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES,
  NO_INTEREST,
  EXCHANGE_FEE,
  LOOKING_FOR,
  QUOTE_TYPE,
  FOLLOW_UP_FEEDBACK,
  PRICE_PER_UNIT
} from "MODULES/OutgoingQuotes/constants";
import * as rules from "app/lib/validation/rules";
import { QUANTITY } from "APP_ROOT/constants";
import { CONDITION, PART_ID } from "MODULES/inventories/constants";
import { INTERNAL_NOTE, OTHER } from "MODULES/shared/constants";
import { COMPANY } from "MODULES/PurchaseOrders/constants";
import { DO_NOT_EXCHANGE } from "MODULES/companies/constants";
import { CORE_DUE_DAYS } from "MODULES/RepairOrders/constants";

export function validateLineItem(lineItem, values, fieldPrefix = null, props) {
  const getFieldVal = field =>
    fieldPrefix ? values[fieldPrefix][field] : values[field];

  const quoteType = getFieldVal(QUOTE_TYPE);

  const inventoryIds = fieldPrefix
    ? values[fieldPrefix].inventory_ids
    : values.inventory_ids;

  if (
    quoteType !== NO_QUOTE &&
    (!inventoryIds || (inventoryIds && inventoryIds.length <= 1))
  ) {
    lineItem.validate(QUANTITY).satisfies(rules.isGreaterThan(0));
    lineItem.validate(QUANTITY, CONDITION).satisfies(rules.required);
  }

  const company = props.quote.get(COMPANY).toJS();

  if (company[DO_NOT_EXCHANGE] && quoteType === EXCHANGE_ONLY) {
    lineItem
      .validate(QUOTE_TYPE)
      .satisfies(
        () => "The Company is flagged with a do not exchange restriction"
      );
  }

  if (quoteType === EXCHANGE_ONLY && !company[DO_NOT_EXCHANGE]) {
    lineItem
      .validate(EXCHANGE_FEE)
      .satisfies(rules.isGreaterThan(0), rules.required);
    lineItem
      .validate(CORE_DUE_DAYS)
      .satisfies(
        rules.isGreaterThanOrEqualTo(0),
        rules.isLessThanOrEqualTo(100)
      );
  }

  if (
    !PRICE_PER_UNIT_OPTIONAL_QUOTE_TYPES.includes(quoteType) &&
    ![NO_INTEREST, LOOKING_FOR].some(f => values[f])
  ) {
    lineItem.validate(PRICE_PER_UNIT).satisfies(rules.required);
  }

  if (getFieldVal(FOLLOW_UP_FEEDBACK) === OTHER) {
    lineItem.validate(INTERNAL_NOTE).satisfies(rules.required);
  }
}

export default function validate(values, props) {
  return validator(values, form => {
    form.validate(PART_ID, QUOTE_TYPE).satisfies(rules.required);
    validateLineItem(form, values, null, props);
  });
}



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/LineItems/Create/validate.js